import Component from '@glimmer/component';
import type { ComponentLike } from '@glint/template';
import { PrismTable } from '@mylighthouse/prism-ember';
import type {
  CustomEmberTableColumn,
  CustomEmberTableRow,
  ThComponentSignature,
} from '@mylighthouse/prism-ember/types/components/prism/table';
import type { Dayjs } from 'dayjs';
import type { Period } from 'lumen/models';
import { DAY_TABLE_SIZES } from 'lumen/utils/constants/general-constants';
import { getPeriodsInRange } from 'lumen/utils/dates/moment-helpers';

interface HotelChannelPricingTablesDayTableSignature {
  Args: {
    data: Period[];
    dateRangeEnd: Dayjs;
    dateRangeStart: Dayjs;
    isLoading: boolean;
    thComponent: ComponentLike<ThComponentSignature>;
  };
}

export default class HotelChannelPricingTablesDayTable extends Component<HotelChannelPricingTablesDayTableSignature> {
  get columns(): CustomEmberTableColumn[] {
    const columns: CustomEmberTableColumn[] = [
      {
        name: '',
        valuePath: '',
        maxWidth: DAY_TABLE_SIZES.NAME_MAX_WIDTH,
      },
    ];

    const range = this.rangeDays;
    if (range) {
      range.forEach((date: Dayjs, index) => {
        const period: Period | undefined = this.args.data[index];

        columns.push({
          id: date.format('YYYY-MM-DD'),
          date,
          period,
          name: '',
          valuePath: '',
          thComponent: this.args.thComponent,
          width: DAY_TABLE_SIZES.VALUE_WIDTH,
          minWidth: DAY_TABLE_SIZES.VALUE_MIN_WIDTH,
          thClassNames: 'day-table-th-no-default-padding',
          isLoading: this.args.isLoading,
        });
      });
    }

    return columns;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rangeDays() {
    return getPeriodsInRange(
      this.args.dateRangeStart,
      this.args.dateRangeEnd,
      'day',
    );
  }

  get rows(): CustomEmberTableRow[] {
    return [];
  }

  <template>
    <PrismTable
      @columns={{this.columns}}
      @fillMode="first-column"
      @removeTableBorder={{true}}
      @rows={{this.rows}}
      @widthConstraint="eq-container"
      class="day-table"
      data-test-id="day-table"
    />
  </template>
}
